import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {Tools} from './Tools';
import {Story, Inc} from './Inc';
import './Story.scss';

interface Props {
    story:Story,
    status:boolean,
    suki?():void,
    isSuki?:boolean,
    isAdd?:boolean,
}

const StoryDetail = (props:Props)=> {
    const suki = ()=>{
        if( props.suki && !props.isSuki && !props.isAdd ){
            props.suki();
        }
    }
    let sukiclass = "notliked";
    if( !props.suki ){
        sukiclass = "none";
    } else if( props.suki && props.isSuki ){
        sukiclass = "liked";
    }
    let count = props.story.suki;
    if( props.isAdd ){
        count++;
    }
    return (
        <div id="story">
            <Table size="small">
                <TableBody>
                    <TableRow>
                        <TableCell className="cell">
                            閲覧
                        </TableCell>
                        <TableCell className="cell" align="right">
                            <FontAwesomeIcon icon="user"/> {props.story.used}人
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="cell">
                            読了
                        </TableCell>
                        <TableCell className="cell" align="right">
                            <FontAwesomeIcon icon="book-open"/> {props.story.completed}人
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="cell">
                            最速スコア
                        </TableCell>
                        <TableCell className="cell" align="right">
                            {Tools.score(props.story.fastest)}秒
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="cell">
                            平均スコア
                        </TableCell>
                        <TableCell className="cell" align="right">
                            {Tools.score(props.story.average)}秒
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="cell">
                            ジャンル
                        </TableCell>
                        <TableCell className="cell" align="right">
                            {Inc.groupNames[props.story.group_id]}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="cell">
                            文字数
                        </TableCell>
                        <TableCell className="cell" align="right">
                            {props.story.moji}字
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="cell">
                            スキ
                        </TableCell>
                        <TableCell className="cell" align="right">
                            <span className={sukiclass} onClick={suki}><FontAwesomeIcon icon="heart"/> {count}</span>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            {props.status &&
            <div style={{textAlign:"right",position:"relative"}}>
                <div style={{position:"absolute",top:"0",left:"0"}}>
                    {props.story.status ? (
                        <span className="public">公開中</span>
                    ):(
                        <span className="private"><FontAwesomeIcon icon="lock" style={{color:"gold"}}/> 下書き</span>
                    )}
                </div>
                作成日: 2019-09-26
            </div>
            }
        </div>
	);
}

export default StoryDetail;